import React from 'react'

const SynthleteSmallLogo = () => {
  return (
        <p className='text-small-logo' style={{letterSpacing: '-0.075em'}}>SYN</p>
  )
}

export default SynthleteSmallLogo
